type LocationType = {
  lat: number;
  lng: number;
};

type titularType = {
  estado?: string;
  cidade_nome?: string;
  municipio?: string;
  bairro?: string;
  codigo_do_bairro?: string;
  _telefone?: string;
  endereco_cobranca?: {
    estado?: string;
    cidade_nome?: string;
    municipio?: string;
    bairro?: string;
    codigo_do_bairro?: string;
    endereco?: string;
    numero?: string;
    complemento?: string;
    referencia?: string;
  };
  [key: string]: any;
};

export class Sale {
  _id?: string;
  cnpj?: string;
  fantasia?: string;
  plano?: any;
  vendedor?: any;
  equipe?: any;
  tipo?: string;
  observacao?: string;
  versao?: string;
  status?: string;
  motivo_devolvido?: string;
  motivo_deletado?: string;
  statusAssinatura?: any;
  titular?: titularType;
  beneficiarios?: any[];
  adiantamento?: any;
  adesao?: any;
  recorrencia?: any;
  produtos?: any[];
  primeiro_vencimento?: Date;
  forma_pagto_parcelas?: string;
  valor_adicionais?: number;
  valor_itens_adicionais?: number;
  valor_plano?: number;
  valor_total?: number;
  imagens?: any;
  processamento_erp?: any;
  data_da_criacao_app?: string;
  datahora_aprovacao?: Date;
  datahora_devolucao?: Date;
  datahora_sicronismo_erp?: Date;
  nao_compra?: any;
  termo?: string;
  createdAt?: Date;
  error?: string;
  origin?: string;
  data_agendamento?: string;

  localizacao?: LocationType;
}
